export const asyncRouterMap = [{
  path: '/',
  component: () => import('@/views/login')
},
{
  path: '/layout',
  component: () => import('@/views/layout'),
  redirect: '/home',
  children: [{
    path: '/home',
    key: 'home',
    iconType: 'user',
    name: '首页',
    component: () => import('@/views/home/index')
  },
  {
    path: '/articles',
    key: 'article-list',
    name: '文章管理',
    iconType: 'user',
    component: () => import('@/views/article-manage/index'),
    redirect: '/article-list',
    children: [{
      path: '/article-list',
      component: () => import('@/views/article-manage/articles')
    },
    {
      path: ':id',
      name: '文章详情',
      component: () => import('@/views/article-manage/article-details')
    }
    ]
  },
  /* {
            path: '/foods',
            name: '食品管理',
            key: 'foods-list',
            iconType: 'user',
            component: () => import('@/views/food-manage/index'),
            redirect: '/foods-list',
            children: [{
              path: '/foods-list',
              component: () => import('@/views/food-manage/food-list')
            }]
          }, */
  {
    path: '/enterprise-manage',
    name: '企业管理',
    key: 'enterprise-manage',
    iconType: 'user',
    component: () => import('@/views/enterprise-manage/enterprise-manage')
  },
  {
    path: '/user-manage',
    name: '用户管理',
    key: 'user-manage',
    iconType: 'user',
    component: () => import('@/views/user-manage/user-manage')
  },
  {
    path: '/worker-manage',
    name: '职工管理',
    key: 'worker-manage',
    iconType: 'user',
    component: () => import('@/views/worker-manage/worker-manage')
  },
  {
    path: '/enterprise-dishes',
    name: '企业菜品',
    key: 'enterprise-dishes',
    iconType: 'user',
    component: () => import('@/views/enterprise-dishes/enterprise-dishes')
  },
  {
    path: '/nutrition-package',
    name: '营养套餐',
    key: 'nutrition-package',
    iconType: 'user',
    component: () => import('@/views/nutrition-package/nutrition-package')
  },
  {
    path: '/common-dishe',
    name: '公共菜品库',
    key: 'common-dishe',
    iconType: 'user',
    component: () => import('@/views/food-manage/common-dishe')
  }

    // {
    //   path: '/role-manage',
    //   name: '角色管理',
    //   key: 'role-manage',
    //   iconType: 'user',
    //   component: () => import('@/views/role-manage/role-manage')
    // },
    // {
    //   path: '/menupage-manage',
    //   name: '菜单管理',
    //   key: 'menupage-manage',
    //   iconType: 'user',
    //   component: () => import('@/views/menupage-manage/menupage-manage')
    // },
    // {
    //   path: '/permission-manage',
    //   name: '权限管理',
    //   key: 'permission-manage',
    //   iconType: 'user',
    //   component: () => import('@/views/permission-manage/permission-manage')
    // }
  ]
},
{
  path: '/writeArticle',
  name: '/writeArticle',
  component: () => import('@/views/article-manage/write-article')
}, {
  path: '/food-check',
  name: '菜品核对',
  key: 'food-check',
  iconType: 'user',
  component: () => import('@/views/food-check/food-check')
}
]
